import { MonitorIcon } from 'lucide-react'

import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@/components/ui'
import { useIsTrialAccount } from '@/modules/account'
import { useIsNarrowScreen } from '../TrialTour/useIsNarrowScreen'
import { usePhoneNoticeConfirmed } from './usePhoneNoticeConfirmed'

const keepOpen = (event: Event) => event.preventDefault()

// Statements are added and reviewed on a computer. A trial user on a phone must confirm they read
// this once, so it cannot flash past on the way to the case.
export const TrialPhoneNotice = () => {
  const isTrial = useIsTrialAccount()
  const isNarrowScreen = useIsNarrowScreen()
  const { isConfirmed, confirm } = usePhoneNoticeConfirmed()

  return (
    <Dialog open={isTrial && isNarrowScreen && !isConfirmed}>
      <DialogContent
        hideClose
        onEscapeKeyDown={keepOpen}
        onInteractOutside={keepOpen}
        className="flex max-w-sm flex-col gap-5 p-6"
      >
        <span className="flex size-11 items-center justify-center rounded-full bg-brand/10 text-brand-deep">
          <MonitorIcon aria-hidden className="size-5" />
        </span>
        <div className="flex flex-col gap-2">
          <DialogTitle className="text-xl font-semibold tracking-tight">
            Continue on your computer
          </DialogTitle>
          <DialogDescription className="text-[15px] leading-relaxed text-muted-foreground">
            Statements are uploaded and reviewed on a larger screen. We emailed
            you a link, so open it on your computer to get started.
          </DialogDescription>
        </div>
        <Button size="lg" className="w-full" onClick={confirm}>
          Got it
        </Button>
      </DialogContent>
    </Dialog>
  )
}
